export function formatDate(date) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString(undefined, options);
}

export function secToHHMMSS(totalSeconds) {
  const sec = Math.floor(totalSeconds % 60);
  const min = Math.floor((totalSeconds / 60) % 60);
  const hr = Math.floor(totalSeconds / 3600);

  const pad = (n) => n.toString().padStart(2, '0');
  return `${pad(hr)}:${pad(min)}:${pad(sec)}`;
}

export function roundNumber(num) {
  return Math.round(num);
}
